"use strict";
exports.__esModule = true;
exports.isExpired = exports.isRevoked = exports.getCredentialStatus = void 0;
var ui_components_core_1 = require("@sphereon/ui-components.core");
var getCredentialStatus = function (credential) {
    if ((0, exports.isRevoked)()) {
        return ui_components_core_1.CredentialStatus.REVOKED;
    }
    else if ((0, exports.isExpired)(credential.expirationDate)) {
        return ui_components_core_1.CredentialStatus.EXPIRED;
    }
    return ui_components_core_1.CredentialStatus.VALID;
};
exports.getCredentialStatus = getCredentialStatus;
var isRevoked = function () {
    return false;
};
exports.isRevoked = isRevoked;
var isExpired = function (value) {
    if (!value) {
        return false;
    }
    var expirationDate = typeof value === 'string' ? new Date(value).valueOf() : value;
    expirationDate = (0, ui_components_core_1.makeEpochMilli)(expirationDate);
    return expirationDate < Date.now();
};
exports.isExpired = isExpired;
